module.exports = __webpack_public_path__ + "static/media/ltl-pallet.e09329bd.svg";